import React, { Component } from 'react';
import BlockButton from 'components/UI/BlockButton';
// import RegistrationTwoStepsForm from "components/Registration/RegistrationTwoStepsForm";
// import Registration from "components/Registration/Registration";
import RegistrationForm from 'components/Registration/RegistrationForm';
import RPPSForm from 'components/Registration/RPPSForm';
// import LoginForm from 'components/Forms/LoginForm';
import Immutable from 'immutable';
import { withRouter } from 'react-router-dom';
// import SubscribeToEventForm from 'components/Forms/SubscribeToEventForm';
// import EventSubscription from 'components/Event/EventSubscription';
// import EventSubscriptionRecap from "components/EventSubscription/EventSubscriptionRecap";
// import EventSendInvite from 'components/Event/EventSendInvite';
// import Paragrapher from 'components/UI/Paragrapher';
import BlockTitle from 'components/UI/BlockTitle';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';
// import { formatDate } from 'helpers/stringUtils'
// import colors from 'config/colors'
import i18n from 'helpers/i18n';
const styles = (theme) => ({
  addButton: {
    backgroundColor: 'transparent',
    padding: 0,
    boxShadow: '0 5px 20px rgba(0,0,0,0.21)',
    '&:hover': {
      boxShadow: '0 5px 5px rgba(0,0,0,0.21)',
      backgroundColor: 'transparent',
    },
  },
  addIcon: {
    width: 50,
    height: 50,
    color: '#EB9250',
    verticalAlign: 'middle',
    margin: '-5px',
  },
  color: {
    color: theme.palette.primary.main,
  },
  // colorTitle: {
  //   color: theme.palette.primary.main
  // },
  inline: {
    display: 'inline-block',
  },
  h2: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    padding: '0 20px 20px',
  },
  h5: {
    textAlign: 'center',
    color: theme.palette.primary.main,
  },
  h6: {
    fontWeight: 'normal',
    color: theme.palette.primary.main,
  },
  caption: {
    display: 'block',
    textAlign: 'center',
    marginBottom: 5,
  },
  body1: {
    textAlign: 'center',
    marginBottom: 10,
  },
  submitButton: {
    transition: [
      theme.transitions.create('color', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      theme.transitions.create('opacity', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    ],
    // backgroundImage: "none",
    // color: theme.palette.text.light,
    // backgroundColor: theme.palette.primary.main,
    fontSize: 22,
    fontWeight: 'bold',
    letterSpacing: '1px',
    padding: '8px 50px',
    // border: "1px transparent solid",
    // display: "flex",
    // "&:hover": {
    //   backgroundImage: "none",
    //   border: "1px " + theme.palette.primary.main + " solid",
    //   backgroundColor: "#fff",
    //   color: theme.palette.primary.main,
    // },
  },
  orangeBlocks: {
    minHeight: '20vh',
    // minHeight: '300px',
    '& .MuiTypography-h4': {
      color: theme.palette.text.light,
      position: 'relative',
      marginBottom: 20,
      width: 'calc(100% - 20px)',
      padding: '10px',
    },
    // '& .MuiTypography-h6': {
    //   color: theme.palette.text.light,
    //   position: 'relative',
    //   marginBottom: 20
    // }
  },
  orangeBlock: {
    color: theme.palette.text.light,
    position: 'relative',
    '&:before': {
      backgroundColor: theme.palette.primary.main,
      top: '0',
      left: '0',
      width: 'calc(100% - 5px)',
      height: '100%',
      content: "' '",
      position: 'absolute',
    },
    '&:nth-of-type(2)': {
      marginLeft: 5,
      flexBasis: 'calc(50% - 5px)',
      maxWidth: 'calc(50% - 5px)',
    },
  },
});
class EventSubscriptionVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMode: false,
      // visibleMode: 'choice',
      // visibleMode: 'register',
      // visibleMode: 'summary',
      userEmail: false,
      log: undefined,
      formStep: 1,
      // formStep: 2,
    };
  }
  // _onClick(e, formType) {
  //   // console.log('clicked', formType)
  //   this.setState({visibleMode: formType});
  // }
  _onSubscriptionError = (kind, user) => {
    this.setState({
      visibleMode: 'unknown_subsriber',
      userEmail: user.email,
    });
  };
  _onSendInvitationComplete = () => {
    this.setState({
      visibleMode: 'invitationComplete',
    });
  };
  _onSendInvitationError = (kind, log) => {
    this.setState({
      visibleMode: kind,
      log,
    });
  };
  // _onSubscriptionComplete(r) {
  //   // console.log('_onSubscriptionComplete', r)
  //   this.setState({visibleMode: 'subscriptionComplete'});
  // }
  _onRegistrationComplete = (r) => {
    // this.setState({visibleMode: 'subscriptionComplete'});
    this._onSubscriptionComplete();
  };
  // _onRegistrationShow = () => {
  //   this.setState({
  //     visibleMode: "register"
  //   });
  // }
  _onRestart = () => {
    this.setState({
      visibleMode: false,
    });
  };
  _onSubscriptionComplete = () => {
    const { onClose, onSubscriptionComplete } = this.props;
    // console.log('_onFormComplete', onSubscriptionComplete)
    if (onSubscriptionComplete !== undefined) onSubscriptionComplete();
    else onClose();
  };
  _showChoice = () => {
    this.setState(
      {
        visibleMode: 'choice',
      },
      () => {
        this.props.onSubscriptionRequest();
      },
    );
  };
  _showRegistration = () => {
    this.setState(
      {
        formStep: 1,
        visibleMode: 'register',
      },
      () => {
        // this.props.onSubscriptionRequest()
      },
    );
  };
  _onRPPSFormComplete = (o) => {
    // console.log('got response', o)
    this.setState({
      rppsValues: o.values,
      formStep: 2,
    });
  };
  _onRPPSFormSubmit = (values) => {
    // console.log(values)
    return false;
  };
  render() {
    const {
      $$event,
      $$events,
      onClose,
      classes,
      history,
      // userRole,
    } = this.props;
    const {
      visibleMode,
      formStep,
      rppsValues,
      // userEmail,
    } = this.state;
    let ef = {};
    if ($$event !== undefined && $$event.get('id') !== undefined) ef.fromEvent = $$event.get('id');
    else if ($$events !== undefined && $$events.get(0) !== undefined)
      ef.fromEvents = JSON.stringify($$events.map((e) => e.get('id')).toArray());
    if (rppsValues !== undefined) {
      rppsValues.map((v, k) => {
        ef[k] = v;
        return true;
      });
    }
    const extraFields = Immutable.fromJS(ef);
    // console.log({
    // ef: extraFields.toJS()
    // })
    const jobCategory = 'isMd';
    return (
      <Grid item xs={12} align="center" container>
        <Choose>
          <When condition={visibleMode === 'choice'}>
            <Grid item xs={12}>
              <Box bgcolor="tercary.light">
                <Typography variant="h3">
                  L'inscription est réservée aux professionnels de santé.
                  <br />
                  Vous devez posséder un numéro RPPS pour vous inscrire.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} container justify="center" className={classes.orangeBlocks}>
              <Grid item xs={6} container alignItems="center" className={classes.orangeBlock}>
                <Grid item xs={12}>
                  <Typography variant="h4" gutterBottom align="center">
                    <span className={classes.inline}>J'ai reçu l'invitation du laboratoire GSK</span>{' '}
                    <span className={classes.inline}>et j'ai un numéro RPPS</span>
                  </Typography>
                  <Button
                    variant="contained"
                    color="default"
                    onClick={(e) => {
                      e.preventDefault();
                      this._showRegistration();
                    }}
                  >
                    S'inscrire
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={6} container alignItems="center" className={classes.orangeBlock}>
                <Grid item xs={12}>
                  <Typography variant="h4" gutterBottom align="center">
                    Je n'ai pas de numéro RPPS{' '}
                  </Typography>
                  <Button
                    variant="contained"
                    color="default"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push('/contact?from=rpps');
                    }}
                  >
                    Nous contacter
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </When>
          <When condition={visibleMode === 'register'}>
            <Grid item xs={12}>
              <Box bgcolor="tercary.light">
                <Typography variant="h3">
                  L'inscription est réservée aux professionnels de santé.
                  <br />
                  Vous devez posséder un numéro RPPS pour vous inscrire.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} container justify="center" className={classes.orangeBlocks}>
              <If condition={formStep === 1}>
                <RPPSForm onSubmit={this._onRPPSFormSubmit} onFormComplete={this._onRPPSFormComplete} />
              </If>
              <If condition={formStep === 2}>
                <RegistrationForm extraFields={extraFields} initialCategories={jobCategory} />
              </If>
            </Grid>
          </When>

          {/*<When condition={visibleMode === "subscriptionComplete"}>
            <Typography
            variant={"h2"}
            classes={{ root: classes.h2 }}
            gutterBottom
            >
            {i18n.get("subscriptionSelfSuccessTitle", { prettyfy: true })}
            </Typography>
            <EventSubscriptionRecap $$events={$$events} />

          <If condition={i18n.has("subscriptionSelfSuccessText")}>
            <Typography
              variant={"h5"}
              classes={{ root: classes.h5 }}
              gutterBottom
              >
              {i18n.get("subscriptionSelfSuccessText")}
            </Typography>
          </If>
          <BlockTitle />

          <BlockButton
            label="Fermer"
            onClick={this._onSubscriptionComplete}
            style={{ margin: "20px auto 10px", display: "block" }}
            />
        </When>*/}

          <Otherwise>
            <Grid item xs={12}>
              <Box my={3}>
                <Button
                  className={classes.submitButton}
                  onClick={this._showChoice}
                  disabled={$$events === undefined || $$events.size === 0}
                  variant="contained"
                  color="secondary"
                >
                  {i18n.get('cardSubscribeToDate', {
                    pretty: false,
                  })}
                </Button>
              </Box>
            </Grid>
          </Otherwise>
        </Choose>
      </Grid>
    );
  }
}
// export default ;
export default withStyles(styles)(withRouter(EventSubscriptionVisitor));



// WEBPACK FOOTER //
// ./src/components/EventSubscription/EventSubscriptionVisitor.jsx